<template>

  
  
  <div class="flex w-full h-full mx-auto p-6">
    <BaseAlert
      v-if="alert.visible"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      :dismissible="true"
      :auto-close="false"
      :close-on-backdrop="true"
      @closed="alert.visible = false"
    />
    
    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-64 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3 class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider">
          Lista de monitores
          <BaseBadge>{{filteredAuthoritiesList.length}}</BaseBadge>
        </h3> 

        <BaseFab @click="newDataModal()" variant="success" size="sm" fixedLeft >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-6 w-6"
            viewBox="0 0 24 24"
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </BaseFab> 
         
      </div>

      <!-- Campo: Search -->
      <BaseInputText 
        name="search"
        v-model="search"  
        placeholder="Búsqueda de monitores"
        :value="search"
      /> 

      <div class="w-full flex gap-1 pt-4 pb-2"> 
        <BaseButton
          variant="secondary"
          v-on:click="statusFilterAuthorities = 'all', filteredAuthoritiesList"
          v-bind:class="[statusFilterAuthorities === 'all' ? 'border-transparent text-white' : 'bg-transparent text-cdmx-blue-light']"
          outline
        >
          Todos
        </BaseButton>

        <BaseButton
          variant="secondary"
          v-on:click="statusFilterAuthorities = 'active', filteredAuthoritiesList"
          v-bind:class="[statusFilterAuthorities === 'active' ? 'border-transparent text-white' : 'bg-transparent text-cdmx-blue-light']"
          outline
        >
          Activos
        </BaseButton>

        <BaseButton
          variant="secondary"
          v-on:click="statusFilterAuthorities = 'inactive', filteredAuthoritiesList"
          v-bind:class="[statusFilterAuthorities === 'inactive' ? 'border-transparent text-white' : 'bg-transparent text-cdmx-blue-light']"
          outline
        >
          Inactivos
        </BaseButton> 
        <BaseButton @click="changeFormOrder" variant="secondary" outline tooltip="Ordenar registros" >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </BaseButton> 
      </div>

      <div class="h-full overflow-auto">
        <!-- Lista de autoridades -->
        <div v-if="filteredAuthoritiesList.length">
          <BaseListItem
            v-for="currentAuthority in filteredAuthoritiesList"
            :key="currentAuthority.id"
            :item="{
              inactive: currentAuthority.inactive,
              image: currentAuthority.profile_image,
              title: `${currentAuthority.name} ${currentAuthority.last_name}`,
              subtitle: currentAuthority.email,
              description: currentAuthority.name_category,
              is_admin: false,
              ...currentAuthority
            }"
            :selected-id="authority && authority.id"
            @select="getAuthority"
          />
        </div>

        <div v-else class="text-gray-500 text-sm italic mt-3 px-5">
          No se encontraron resultados.
        </div>
      </div>
    </div>
    <div class="bg-white shadow-lg rounded-lg w-4/6 mx-auto p-8 flex flex-col items-center text-center">
      <!-- Imagen -->
      <div class="flex justify-center mb-6">
        <img
          :src="authority.profile_image"
          class="object-cover h-40 w-40 rounded-full border-4"
          :class="authority.inactive ? 'border-cdmx-red' : 'border-cdmx-green'"
        />
      </div>

      <!-- Información personal -->
      <div class="w-full">
        <h2 class="font-bold text-gray-900 text-lg mb-3">Información Personal</h2>
        <div class="text-sm space-y-2">
          <div>
            <span class="font-bold text-gray-900">Nombre:</span>
            <span class="ml-2 text-gray-700">{{ authority.name }} {{ authority.last_name }}</span>
          </div>
          <div>
            <span class="font-bold text-gray-900">Correo:</span>
            <span class="ml-2 text-gray-700">{{ authority.email }}</span>
          </div>
          <div v-if="authority.address">
            <span class="font-bold text-gray-900">Dirección:</span>
            <span class="ml-2 text-gray-700">{{ authority.address }}</span>
          </div>
          <div v-if="authority.phone_number">
            <span class="font-bold text-gray-900">Teléfono:</span>
            <span class="ml-2 text-gray-700">{{ authority.phone_number }}</span>
          </div>
        </div>
      </div>

      <!-- Información laboral -->
      <div class="w-full mt-8">
        <h2 class="font-bold text-gray-900 text-lg mb-3">Información Laboral</h2>
        <div class="text-sm space-y-2">
          <div>
            <span class="font-bold">Proyecto:</span>
            <span class="px-2">{{ authority.name_category}}</span>
          </div>
          <div>
            <span class="font-bold">Autenticación:</span>
            <span class="px-2">{{ authority.auth_id }}</span>
          </div>
          <div v-if="authority.sex">
            <span class="font-bold">Sexo:</span>
            <span class="px-2">{{ authority.sex }}</span>
          </div>
          <div v-if="authority.age">
            <span class="font-bold">Edad:</span>
            <span class="px-2">{{ authority.age }} años</span>
          </div>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex flex-wrap justify-center gap-3 mt-8">
        <BaseButton
          @click="updateDataModal(authority)"
          variant="info"
          icon="pen"
          outline
        >
          Editar
        </BaseButton>

        <BaseButton
          v-if="authority.inactive"
          @click="updateActivated(false)"
          variant="success"
          icon="check-circle"
          outline
        >
          Activar
        </BaseButton>

        <BaseButton
          v-if="!authority.inactive"
          @click="updateActivated(true)"
          variant="danger"
          icon="times-circle"
          outline
        >
          Desactivar
        </BaseButton>

        <BaseButton
          @click="showingConfirm = true"
          variant="danger"
          icon="trash-alt"
          outline
        >
          Eliminar
        </BaseButton>
      </div>
    </div>


    <authority-chat-modal
      :showing="showChatModal"
      @close="closeChatsModal"
      :chartList="chartList"
      :alert="chatAlert"
    ></authority-chat-modal>

    <authority-modal
      :newAuthority="newAuthority"
      :showing="showAuthorityModal"
      @updateAuthority="updateAuthority"
      @updateAllAuthority="updateAllAuthority"
      @close="showAuthorityModal = false"
      @trigger-alert="handleShowAlert"
    ></authority-modal>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar este monitor?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateActivity()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>


<script>
import { backend_url } from "../config/url.config.ts";
import authorityModal from "./AuthorityModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import moment from "moment";
import axios from "axios";
import AuthorityChatModal from "./AuthorityChatModal";
import XLSX from 'xlsx';
import BaseButton from "./atoms/BaseButton.vue";
import BaseFab from "./atoms/BaseFab.vue";
import BaseBadge from "./atoms/BaseBadge.vue";
import BaseInputText from "./atoms/BaseInputText.vue";
import BaseListItem from "./atoms/BaseListItem.vue";
import defaultProfileImg from "@/assets/default-profile.png";
import BaseAlert from "./atoms/BaseAlert.vue";  

export default {
  name: "authoritiesList",
  data() {
    return {
      chatAlert: null,
      chartList: null,
      showChatModal: false,
      showingConfirm: false,
      showingSuccessDelete: false,
      json_fields: {
        Nombre: "name",
        Apellido: "last_name",
        Categoria: "name_category",
        Correo: "email",
        Edad: "age",
        Sexo: "sex",
        Telefono: "phone_number",
        Dirección: "address",
        "Url de perfil": "profile_image",
        ID: "auth_id",
        // Dispositivo: "device_id"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      showAuthorityModal: false,
      selectedIndex: 0,
      authoritiesList: [],
      authority: null,
      newAuthority: false,
      search: "",
      searchByday: "",
      statusFilterAuthorities: "all",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      alerts: [],
      alertFilter: "assigned",
      categoryFilter: "-1",
      authorityCategories: [],
      formOrder: "upward",
      alert: {
        visible: false,
        type: '',
        title: '',
        message: '',
      },
    };
  },
  components: {
    authorityModal,
    AlertDialog,
    AuthorityChatModal,
    BaseButton,
    BaseFab,
    BaseBadge,
    BaseInputText,
    BaseListItem,
    BaseAlert
  },
  created() {
    let that = this; 
  },
  mounted() {
    this.getAuthoritiesList();
    this.fetchAuthorityCategories();
  },
  methods: {
    handleShowAlert(alertData) {
      this.alert = {
        visible: true,
        ...alertData,
      };
    },
    showAlertChatModal(alert){
      axios
        .get(backend_url + "/api/messages/"+alert.id, this.config)
        .then(response => {
          console.log(response)
          this.chartList = response.data.messages
          this.chatAlert = alert
          this.showChatModal=true; 
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        })
    },
    closeChatsModal() {
      this.showChatModal = false;
    },
    startDownload(){
      this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
        "module": "Autoridades", 
        "action": "Descarga de información de todos los monitores", 
        "observation": 'Información personal de los monitores',
        "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //console.log(response)
      })
      .catch(error => {
        //console.log(error)
      });
    },
    onexport () {
      axios
        .post(backend_url + "/api/messages/authority",{autoridad_id: this.authority.id}, this.config)
        .then(response => {
          let chats = []
          let groupChat = {}

          response.data.messages.forEach(message => {
            if(groupChat.hasOwnProperty(message.alert_id)){
              let text = '';
              if(message.user_type == "visitor"){
                text = `Visitor ${moment(message.date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }else{
                text = `Autoridad ${moment(message.date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }

              groupChat[message.alert_id] += text;
            }else{
              let text = '';
              if(message.user_type == "visitor"){
                text = `Visitor ${moment(message.date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }else{
                text = `Autoridad ${moment(message.date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }

              groupChat[message.alert_id] = text;
            }
          })

          Object.keys(groupChat).forEach(key => {
            const chat = {
              id: `F-${key}`,
              chat: groupChat[key]
            }
            chats.push(chat)
          });

          const info = {
            Nombre: this.authority.name,
            Apellido: this.authority.last_name,
            Correo: this.authority.email,
            Telefono: this.authority.phone_number,
            Autenticación: this.authority.auth_id,
            // Dispositivo: this.authority.device_id,
            Edad: this.authority.age,
            Sexo: this.authority.sex
          };

          let alerts = [];
          this.alerts.forEach(alert => {
            const new_alert = {
              id: `F-${alert.id}`,
              Nombre: alert.user_info.name,
              Apellido: alert.user_info.last_name,
              Comentario: alert.comentario_visitante,
              Reporte: alert.comentario_autoridad,
              Fecha: moment(alert.fecha_alerta).format("DD/MM/YYYY hh:mm A"),
              Estado: alert.status
            };
            alerts.push(new_alert);
          });

          const autorityInfo = XLSX.utils.json_to_sheet([info]);
          const alertsList = XLSX.utils.json_to_sheet(alerts);
          const chatList = XLSX.utils.json_to_sheet(chats);

          var wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(wb, autorityInfo, "Autoridad");
          XLSX.utils.book_append_sheet(wb, alertsList, "Alertas");
          if(chats.length>0) { XLSX.utils.book_append_sheet(wb, chatList, "Chats"); }

          XLSX.writeFile(wb, "Autoridad.xlsx");

          this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
            "module": "Autoridades", 
            "action": "Descarga de información de una autoridad", 
            "observation": `${this.authority.name} ${this.authority.last_name}`,
            "email": localStorage.getItem("email")
            },
            this.config
          )
          .then(response => {
            //console.log(response)
          })
          .catch(error => {
            //console.log(error)
          });
        })
        .catch(error => {
          console.log("error",error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.errored = true;
        })
    },
    getAuthoritiesList: function() {
      axios
        .get(backend_url + "/authorities", this.config)
        .then(response => {
          this.authoritiesList = response.data;
          this.authoritiesList.forEach(data => {
            if (data.profile_image != null) {
              data.profile_image = backend_url + "/" + data.profile_image;
            } else {
              data.profile_image = defaultProfileImg;
            }
          });

          if (this.authoritiesList.length > 0) {
            this.authority = !this.authority ? this.authoritiesList[0] : this.authority ;
            //this.fetchAuthorityAlerts(this.authority.id);
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getAuthority: function(authority) {
      this.authority = authority;
      console.log(this.authority);
      //this.fetchAuthorityAlerts(authority.id);
    },

    updateDataModal: function(authority) {
      this.showAuthorityModal = true;
      this.newAuthority = false; 
      
      EventBus.$emit("editModal", authority);
    },

    newDataModal: function() {
      this.showAuthorityModal = true;
      this.newAuthority = true;
    },

    updateAuthority: function(Authority) {
      console.log("updateAuthority")
      this.authoritiesList.forEach(authority => {
        if (authority.id == Authority.id) {
          console.log(authority)
          let updateAuthority = Object.assign({}, Authority);
          authority.name = updateAuthority.name;
          authority.last_name = updateAuthority.last_name;
          authority.address = updateAuthority.address;
          authority.phone_number = updateAuthority.phone_number;
          authority.age = updateAuthority.age;
          authority.sex = updateAuthority.sex;
          authority.auth_id = updateAuthority.auth_id;
          authority.category_id = updateAuthority.category_id;
          authority.name_category = updateAuthority.name_category;
          authority.profile_image = updateAuthority.profile_image;
        }
      });
    },
    updateAllAuthority: function() {
      this.getAuthoritiesList();
    },

    updateActivity: function(status) {
      this.axios
        .delete(backend_url + "/authorities/" + this.authority.id, this.config)
        .then(response => {
          return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
            "module": "Monitores", 
            "action": "Eliminación de un monitor", 
            "observation": `${this.authority.name} ${this.authority.last_name}`,
            "email": localStorage.getItem("email")
            },
            this.config
          )
        })
        .then(response => {
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
          this.getAuthoritiesList();
        })
        .catch(error => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    updateActivated: function(status) {
      this.axios
        .post(
          backend_url + "/users/updateActivity",
          {
            inactive: status,
            id: this.authority.user_id
          },
          this.config
        )
        .then(response => {
          this.authority.inactive = status;
          //console.log(status)
          const action = !status ? "Activación de un monitor" : "Desactivación de un monitor";
          this.alert = {
            visible: true,
            type: 'success',
            title: 'Acciòn realizada exitosamente',
            message: action,
          }
          return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
            "module": "Monitores", 
            "action": action, 
            "observation": `${this.authority.name} ${this.authority.last_name}`,
            "email": localStorage.getItem("email")
            },
            this.config
          )

        })
        .then(() => {
          this.getAuthoritiesList();
        })
        .catch(error => {
          console.error(error.response);
          this.alert = {
            visible: true,
            type: 'error',
            title: 'Ocurrio un error',
            message: error.response,
          }
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchAuthorityAlerts(authorityId) {
      this.axios
        .get(
          backend_url + "/api/alerts/getallbyauthority/" + authorityId,
          this.config
        )
        .then(response => {
          this.alerts = response.data;
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchAuthorityCategories() {
      this.axios
        .get(backend_url + "/authorities/categories/listAll", this.config)
        .then(response => {
          this.authorityCategories = response.data.categories;
        })
        .catch(error => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    loadDefaultImg(event) {
      event.target.src =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    clearSelectedDate() {
      this.searchByday = "";
    }
  },
  computed: {
    filteredAuthoritiesList: function() {
      console.log('this.searcht', this.search)
      return this.authoritiesList
        .filter(authority => {
          let full_name = authority.name + " " + authority.last_name;
          switch (this.statusFilterAuthorities) {
            case "all":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  authority.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  authority.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  authority.category_id === this.categoryFilter)
              );
            case "active":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  authority.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  authority.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                !authority.inactive &&
                (this.categoryFilter === "-1" ||
                  authority.category_id === this.categoryFilter)
              );
            case "inactive":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  authority.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  authority.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                authority.inactive &&
                (this.categoryFilter === "-1" ||
                  authority.category_id === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          } else {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
    },
    filteredAlerts() {
      return this.alerts.filter(alert => {
        let date = moment(alert.fecha_alerta).format("YYYY-MM-DD");

        switch (this.alertFilter) {
          // case "all":
          //   return date.toLowerCase().includes(this.searchByday.toLowerCase());
          case "attended":
            if (alert.status === "ATENDIDA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
          case "assigned":
            if (alert.status === "ASIGNADA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
          // case "open":
          //   if (alert.status === "ABIERTA") {
          //     if (
          //       this.searchByday != "" &&
          //       date.toLowerCase().includes(this.searchByday.toLowerCase())
          //     ) {
          //       return true;
          //     } else {
          //       false;
          //     }
          //   } else {
          //     return false;
          //   }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bg-semi-75 {
    background-color: rgba(0, 0, 0, 0.75);
  }
</style>
